// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"95d6fecc","188":"55a71117","453":"5a27d219","632":"0e001494","708":"f8fd490f","753":"9a141105","836":"1320c999","946":"1f70d2e6"}[chunkId] + ".chunk.js";
};